import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import * as Yup from 'yup';

import useRequest from '@common/react/hooks/useRequest';

import FormikField from '@app/components/Forms/CustomFormikField/CustomFormikField';
import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import { TypeRecover } from '@app/components/UI/Login/RecoverForm';
import RecoverFormLayout from '@app/components/UI/Login/RecoverFormLayout';

interface Props {
	onChangeTypeRecover: (e: TypeRecover | null) => void;
	onChangeEmail: (val: string) => void;
}

const mailIcon = require('@app/images/icons/mail.svg');

const EmailRecoverForm: React.FC<Props> = ({ onChangeTypeRecover, onChangeEmail }) => {
	const request = useRequest();

	return (
		<RecoverFormLayout
			title="Send Code by Email"
			description="Enter the email address associated with your account. If we find a match we'll email a code."
			initialValues={{
				email: '',
				captcha: '',
			}}
			validationSchema={Yup.object({
				email: Yup.string().email('Value must be a valid Email address').required('Value must be a valid Email address'),
				captcha: Yup.string().required('Please check the box to submit this form'),
			})}
			onBack={() => onChangeTypeRecover(null)}
			onSubmit={(values) => (
				request('recover', values)
					.then(() => {
						onChangeTypeRecover(TypeRecover.verifyCode);
						onChangeEmail(values?.email || '');
					})
			)}
			successfulMessage="Message sent! Please check your mailbox."
			render={(formikBag) => (
				<div className="login-form__fields">
					<CustomInput name="email" placeholder="Email Address" formikBag={formikBag} prefixIcon={mailIcon} />
					<FormikField
						containerClassName="captcha"
						fieldName="captcha"
						render={(fieldProps) => (
							<ReCAPTCHA
								sitekey="6LezTMIcAAAAACaXvLNse5bmTJpwqs0Ezm_bhTrU"
								onChange={(value) => {
									if (value) {
										formikBag.setFieldValue('captcha', value || '');
									} else {
										formikBag.setFieldValue('captcha', '');
									}
								}}
								onExpired={() => {
									formikBag.setFieldValue('captcha', 'expired');
								}}
								hl="en"
							/>
						)}
					/>
				</div>
			)}
		/>
	);
};

export default EmailRecoverForm;
